import { useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import {
  UniversalFilterCompanyNewFinTagsValue,
  UniversalFilterCompanyNewFinTagsModes,
  UniversalFilterCompanyNewFinTagsFilterState,
  UniversalFilterCompanyNewFinTagsOnChange,
  UniversalFilterCompanyNewFinTagID
} from '../../UniversalFilterCompanyNewFinTags.types';

interface UniversalFilterCompanyNewFinTagsFilterStateOptions {
  onChange: UniversalFilterCompanyNewFinTagsOnChange;
}

function useUniversalFilterCompanyNewFinTagsFilterState({
  onChange
}: UniversalFilterCompanyNewFinTagsFilterStateOptions) {
  // All modes and options available in handleApplyFilterState
  // must be implemented in handleParseFilterValue too
  const handleApplyFilterState = useCallback<
    (filterState: UniversalFilterCompanyNewFinTagsFilterState) => void
  >(
    (filterState) => {
      const tagIds = filterState?.tagIds;

      if (
        filterState?.mode === UniversalFilterCompanyNewFinTagsModes.IS_ANY_OF
      ) {
        onChange(isEmpty(tagIds) ? undefined : { in: tagIds });
        return;
      }

      if (
        filterState?.mode === UniversalFilterCompanyNewFinTagsModes.IS_NONE_OF
      ) {
        onChange(isEmpty(tagIds) ? undefined : { notIn: tagIds });
        return;
      }

      onChange();
    },
    [onChange]
  );

  const handleParseFilterValue = useCallback<
    (
      filterValue: UniversalFilterCompanyNewFinTagsValue
    ) => UniversalFilterCompanyNewFinTagsFilterState | undefined
  >((filterValue) => {
    if (isNil(filterValue)) {
      return undefined;
    }

    if (!isEmpty(filterValue.in)) {
      return {
        mode: UniversalFilterCompanyNewFinTagsModes.IS_ANY_OF,
        tagIds: filterValue.in as UniversalFilterCompanyNewFinTagID[]
      };
    }

    if (!isEmpty(filterValue.notIn)) {
      return {
        mode: UniversalFilterCompanyNewFinTagsModes.IS_NONE_OF,
        tagIds: filterValue.notIn as UniversalFilterCompanyNewFinTagID[]
      };
    }

    return undefined;
  }, []);

  return { handleApplyFilterState, handleParseFilterValue };
}

export default useUniversalFilterCompanyNewFinTagsFilterState;
